import {
	REFRESH_STATES,
	SET_STATES,
	SET_ADVANCED
} from './types'

const initialState = {
	states: [],
	refresh: false,
	initialize: true,
    isAdvance: false
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_STATES:
			return {
				...state,
				refresh: true,
				initialize: true,
				states: [],
			}
		
		case SET_STATES:
			return {
				...state,
				refresh: false,
				initialize: false,
				states: [...state.states, ...payload]
			}
		case SET_ADVANCED:
			return {
				...state,
				isAdvance: payload,
			}

		default:
			return state;

	}

}

export default reducer